import { useEffect } from 'react';
import head from 'lodash/head';
export function useHideHeaderAndFooter(isHidden) {
    useEffect(() => {
        if (isHidden) {
            const headers = document.getElementsByTagName('header');
            const footers = document.getElementsByTagName('footer');
            const header = head(headers);
            const footer = head(footers);
            if (header) {
                header.style.display = 'none';
            }
            if (footer) {
                footer.style.display = 'none';
            }
        }
    }, [isHidden]);
}
